import React from "react";
import { IconButton, IconButtonProps } from "@mui/material";

// A round blue action button for grid-like contexts (its icon/emoji is the children). The round action
// counterpart of DeleteIconButton, so compact actions read the same across the app.
const ActionIconButton = ({ sx, children, ...props }: IconButtonProps) => (
  <IconButton
    size="small"
    sx={{
      bgcolor: "primary.main",
      color: "common.white",
      boxShadow: 2,
      "&:hover": { bgcolor: "primary.dark", boxShadow: 4 },
      ...sx,
    }}
    {...props}
  >
    {children}
  </IconButton>
);

export default ActionIconButton;
